import React from "react";
import { TopNavigation } from "./containers/topNavigation";
import { VerificationStatus } from "./pages/verificationStatus";
import { CardView } from "./pages/cardView";
import { ResetPassword } from "./pages/forgetPassword";
import { TermsAndCondition } from "./pages/termsAndCondition";
import { PrivacyPolicy } from "./pages/privacyPolicy";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DeleteUser } from "./pages/deleteUser";

function App() {
  return (
    <Router basename="/">
      <div>
        <TopNavigation />
        <Routes>
          <Route
            path="/user/verifyemail/:id"
            element={<VerificationStatus />}
          />

          <Route path="/carddetails/:id" element={<CardView />} />

          <Route path="/delete-user-account" element={<DeleteUser />} />
          <Route path="/user/reset-password/:id" element={<ResetPassword />} />

          <Route path="/terms-of-service" element={<TermsAndCondition />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
